export default __webpack_public_path__ + "static/media/_DSC9302.0c0c6c1c.jpg";